import { z } from 'zod'

import { ChannelType } from 'common/core/constants/ChannelType'
import { DefaultReplyType, defaultReplySchema } from 'shared/api/common/schemas/flow/defaultReply'

export const defaultReplyApiSchemas = {
  getData: {
    query: z.object({
      channel: z.enum(ChannelType),
    }),
    path: z.undefined(),
    response: defaultReplySchema,
  },
  switch: {
    query: z.undefined(),
    path: z.undefined(),
    response: defaultReplySchema,
    request: z.object({
      channel: z.enum(ChannelType),
      default_enabled: z.number(),
    }),
  },
  changeType: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      channel: z.enum(ChannelType),
      type: z.enum(DefaultReplyType),
    }),
    response: defaultReplySchema,
  },
  replaceFlow: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      channel: z.enum(ChannelType),
      flow_ns: z.string().nullable().optional(),
    }),
    response: defaultReplySchema,
  },
  changeSource: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      channel: z.enum(ChannelType),
      sources: z.object({
        direct: z.boolean(),
        story: z.boolean(),
      }),
    }),
    response: defaultReplySchema,
  },
  removeFlow: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      channel: z.enum(ChannelType),
    }),
    response: defaultReplySchema,
  },
}
